const searchNode = (data: any, path: string) => {
  for (let i = 0; i < data?.length; i++) {
    const item = data[i];
    if (item.path === path) {
      return item;
    }

    if (item.children && Array.isArray(item.children)) {
      const found = searchNode(item.children, path) as any;
      if (found) {
        return found;
      }
    }
  }

  return null;
};
export default searchNode